import React, { useEffect } from "react";
import { runtimeConfig } from "../../config/runtimeConfig";

/**
 * Legacy consumer-SPA /scheduler* entry — TPG Scheduler lives in Blade Admin.
 * Redirects to adminBaseUrl + scheduler… so subscribers never see admin UI.
 */
function SchedulerAdminRedirect({ location }) {
  const path = (location && location.pathname) || "/scheduler";
  const search = (location && location.search) || "";
  // /scheduler → scheduler, /scheduler/programming → scheduler/programming
  const suffix = path.replace(/^\//, "");
  const target =
    String(runtimeConfig.adminBaseUrl || "").replace(/\/+$/, "/") +
    suffix +
    search;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div
      className="main-sec-content"
      style={{ padding: "3rem 1.5rem", maxWidth: "36rem" }}
      role="status"
    >
      <h1 style={{ fontSize: "1.35rem", marginBottom: "0.75rem" }}>
        TPG Scheduler moved to Administrator
      </h1>
      <p style={{ marginBottom: "1rem" }}>
        Broadcast scheduling is managed from the Admin Dashboard, not the
        subscriber site. Redirecting…
      </p>
      <p>
        <a href={target}>Open Admin Scheduler</a>
        {" · "}
        <a href="/home">Return to Home</a>
      </p>
    </div>
  );
}

export default SchedulerAdminRedirect;
